<template>
  <v-container fluid>
    <v-row no-gutters class="app-bar">
      <v-app-bar-nav-icon
        v-show="$vuetify.breakpoint.smAndDown"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-breadcrumbs
        style="padding-left: 1rem"
        large
        divider="/"
        :items="breadcrumbs"
      >
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.to"
            class="text-overline"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <v-spacer></v-spacer>
      <router-link
        v-if="loggedIn"
        :to="{ name: 'tutorials.setting' }"
        class="d-flex align-center"
      >
        <v-btn icon class="profile">
          <v-icon>mdi-account-outline</v-icon>
        </v-btn>
      </router-link>
    </v-row>
    <v-navigation-drawer
      v-model="drawer"
      v-show="drawer && $vuetify.breakpoint.smAndDown"
      absolute
      temporary
    >
      <Navigation />
    </v-navigation-drawer>
  </v-container>
</template>

<style scoped>
.app-bar {
  padding: 1rem 0;
  border-bottom: 1px solid #d8d8d8;
}

.v-application ul {
  padding: 0;
}

.profile {
  margin-right: 1rem;
}

.v-breadcrumbs li {
  display: unset;
}
</style>

<script>
import { useUserServiceInject } from "@/context";
import Navigation from "@/components/Navigation.vue";

export default {
  name: "AppBar",
  components: { Navigation },
  computed: {
    breadcrumbs() {
      if (typeof this.$route.meta.breadcrumb === "function") {
        return this.$route.meta.breadcrumb.call(this, this.$route);
      }
      return this.$route.meta.breadcrumb;
    },
  },
  setup() {
    const { loggedIn } = useUserServiceInject();
    return { loggedIn };
  },
  data() {
    return {
      drawer: false,
      group: null,
    };
  },

  watch: {
    group() {
      this.drawer = false;
    },
  },
};
</script>
